import {useRef} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {offerListGuideTourName} from "../../offer/list/constants/offer_list_guide_tour";
import {SlotOrderType} from "../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../search/constants/search_form_with_drawer_height";
import {tdaDesktopHeight} from "../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../store/hooks";
import {useCookieBotObserver} from "../hooks/use_cookie_bot_observer";
import {WideContentStyled, Wrapper} from "./OfferListNavigationShared";

export const getListFriendlyLink = ({friendlySlug, offerListSubFilterSlug}: {friendlySlug: string; offerListSubFilterSlug?: string}) => {
    return offerListSubFilterSlug
        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
        : rpAppLink.offer.listFriendly({friendlySlug});
};

export const getAbroadListFriendlyLink = ({friendlySlug, country, abroadRegionSlug}: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => {
    return rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug});
};

export const OfferListNavigation = () => {
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const list = useAppSelector((state) => state.offerList.list);
    const isListingNavigationSticky = useAppSelector((state) => state.offerListing.isListingNavigationSticky);
    const selectedRegions = useAppSelector((state) => state.offerList.selectedRegions);
    const navigationRef = useRef<HTMLDivElement>(null);
    const isMounted = useIsMounted();
    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    /**
     * TODO: Navigation height changes between screen sizes, we should put the height in
     *  redux instead of relying on fixed values, not adding it currently, afraid of shock on business side
     */
    // useEffect(() => {
    //     const navigationResizeObserver = new ResizeObserver((entries) => {
    //         for (const entry of entries) {
    //             const navigation = entry.contentRect;
    //             const height = navigation.height;
    //         }
    //     });
    //
    //     if (navigationRef.current) {
    //         navigationResizeObserver.observe(navigationRef.current);
    //     }
    //
    //     return () => {
    //         navigationResizeObserver.disconnect();
    //     };
    // }, []);

    return (
        <Wrapper navigationState={navigationState} isMounted={isMounted} ref={navigationRef}>
            <WideContentStyled navigationState={navigationState}>
                <SearchFormWithDrawer
                    multiRegionLink={rpAppLink.offer.multiList}
                    latestQuery={list.latestQuery}
                    selectedRegions={selectedRegions}
                    listFriendlyLink={getListFriendlyLink}
                    abroadListFriendlyLink={getAbroadListFriendlyLink}
                    sortActive
                    shouldRenderListBackBtn
                    slotOrder={SlotOrderType.ROW_REVERSE}
                    showTopFilters
                    blendTop={`${tdaDesktopHeight + searchFormWithDrawerHeight}px`}
                    blendHeightDecrease={`${tdaDesktopHeight + searchFormWithDrawerHeight + navigationHeight}px`}
                    disableLocationSearch={(!isMobile && isListingNavigationSticky) || isCookieBotOpen}
                    guideTourName={offerListGuideTourName}
                    autoFocusOnInit
                />
            </WideContentStyled>
        </Wrapper>
    );
};
import {useRef} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {offerListGuideTourName} from "../../offer/list/constants/offer_list_guide_tour";
import {SlotOrderType} from "../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../search/constants/search_form_with_drawer_height";
import {tdaDesktopHeight} from "../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../store/hooks";
import {useCookieBotObserver} from "../hooks/use_cookie_bot_observer";
import {WideContentStyled, Wrapper} from "./OfferListNavigationShared";

export const getListFriendlyLink = ({friendlySlug, offerListSubFilterSlug}: {friendlySlug: string; offerListSubFilterSlug?: string}) => {
    return offerListSubFilterSlug
        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
        : rpAppLink.offer.listFriendly({friendlySlug});
};

export const getAbroadListFriendlyLink = ({friendlySlug, country, abroadRegionSlug}: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => {
    return rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug});
};

export const OfferListNavigation = () => {
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const list = useAppSelector((state) => state.offerList.list);
    const isListingNavigationSticky = useAppSelector((state) => state.offerListing.isListingNavigationSticky);
    const selectedRegions = useAppSelector((state) => state.offerList.selectedRegions);
    const navigationRef = useRef<HTMLDivElement>(null);
    const isMounted = useIsMounted();
    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    /**
     * TODO: Navigation height changes between screen sizes, we should put the height in
     *  redux instead of relying on fixed values, not adding it currently, afraid of shock on business side
     */
    // useEffect(() => {
    //     const navigationResizeObserver = new ResizeObserver((entries) => {
    //         for (const entry of entries) {
    //             const navigation = entry.contentRect;
    //             const height = navigation.height;
    //         }
    //     });
    //
    //     if (navigationRef.current) {
    //         navigationResizeObserver.observe(navigationRef.current);
    //     }
    //
    //     return () => {
    //         navigationResizeObserver.disconnect();
    //     };
    // }, []);

    return (
        <Wrapper navigationState={navigationState} isMounted={isMounted} ref={navigationRef}>
            <WideContentStyled navigationState={navigationState}>
                <SearchFormWithDrawer
                    multiRegionLink={rpAppLink.offer.multiList}
                    latestQuery={list.latestQuery}
                    selectedRegions={selectedRegions}
                    listFriendlyLink={getListFriendlyLink}
                    abroadListFriendlyLink={getAbroadListFriendlyLink}
                    sortActive
                    shouldRenderListBackBtn
                    slotOrder={SlotOrderType.ROW_REVERSE}
                    showTopFilters
                    blendTop={`${tdaDesktopHeight + searchFormWithDrawerHeight}px`}
                    blendHeightDecrease={`${tdaDesktopHeight + searchFormWithDrawerHeight + navigationHeight}px`}
                    disableLocationSearch={(!isMobile && isListingNavigationSticky) || isCookieBotOpen}
                    guideTourName={offerListGuideTourName}
                    autoFocusOnInit
                />
            </WideContentStyled>
        </Wrapper>
    );
};
